import {ProductEntity, ProductProperties} from "@/entity/ProductEntity";
import {BasketContextDataEntity} from "@/entity/BasketContextDataEntity";
import {ProductImagesEntity} from "@/entity/ProductImagesEntity";
import ProductVariantOptions from "@/views/Product/ProductVariantOptions.vue";
import {PriceTypeEnum} from "@/entity/PriceTypeEnum";

export class BasketEntity{
    basket_id!:number;
    context_data:BasketContextDataEntity = new BasketContextDataEntity();
    created_at!:string;
    price_type_id!:PriceTypeEnum;
    image_url!:string;
    order_id!:number;
    piece!:number;
    price!:any;
    kdv!:number;
    piece_price!:any;
    product_id!:number;
    product_property_id!:number;
    session_id!:number;
    is_upgrade!:any;
    status!:number;
    thumb_url!:string;
    updated_at!:string;
    product!:ProductEntity;
    product_option!:any;
    product_stock!:any;
    product_images!:ProductImagesEntity;
    tc_kimlik_no!:number;
    eicra_eposta!:number;
    Rumuz!:string;
    ay_sayisi!:number;
}